<template>
    <div>
        <div class="search-layout">
            <el-input placeholder="请输入服务名称" style="width: 225px;" class="mr10 mb10" v-model="seachTitle">
                <template slot="prepend">服务名称</template>
            </el-input>

            <el-button class="el-search-btn" type="primary" icon="el-icon-search" @click="getMerchantMSUList()">搜索</el-button>
        </div>
        <div class="bidding-enroll">
            <div class="bidding-info">
                <div class="info">
                    <ul class="info-list">
                        <li class="info-item" v-for="msu in servcList">
                            <label>
                                <el-radio class="radio" v-model="msuId" :label="msu.id">{{msu.title}}</el-radio>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import servcApi from '../../api/servc'
    export default{
        name: 'swb-servc-for-select',
        desc: '单选msu',
        data: function () {
            return {
                servcList: [],
                msuId: null,
                seachTitle: null,
            }
        },
        created: function () {
            this.getMerchantMSUList();
        },
        methods: {
            // 获取商户自己的MSU列表
            getMerchantMSUList: function () {
                let self = this;
                let filter = {};
                if(null != self.seachTitle) {
                    filter.title = self.seachTitle;
                }
                let theLoad = MsgBox.loading();
                servcApi.getMsuListByContext(filter, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.servcList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getDlgResult: function () {
                let self = this;
                let msuId = self.msuId;
                let servcList = self.servcList;
                let result = {};
                let msu = {};
                for(let i = 0; i < servcList.length; i++) {
                    if(msuId == servcList[i].id) {
                        result.type = 'info';
                        msu = servcList[i];
                    }
                }
                if(msuId != null) {
                    result.msu = msu;
                } else {
                    MsgBox.warning('请选择服务');
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/servc/ServcForSelect.vue